import type { GridColDef, GridValidRowModel } from '@mui/x-data-grid-premium';

/** MUI's Excel serializer calls `.getFullYear()` on any truthy `date`/`dateTime` cell value. */
export function asGridDateValue(value: unknown): Date | null | undefined {
  if (value === null || value === undefined) return value;

  let date: Date | null = null;
  if (value instanceof Date) date = value;
  else if (typeof value === 'string' || typeof value === 'number') date = new Date(value);

  return date !== null && !Number.isNaN(date.getTime()) ? date : null;
}

/** A `date`/`dateTime` column with no `valueGetter` reads the raw GraphQL ISO string; give it the Date MUI requires. */
export function withDateValueGetter<T extends GridValidRowModel>(column: GridColDef<T>): GridColDef<T> {
  if ((column.type !== 'date' && column.type !== 'dateTime') || column.valueGetter !== undefined) return column;

  return { ...column, valueGetter: asGridDateValue };
}
